module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/timeline_line_1-c40f90a42ffd9e1acdae9bdadd0276c7.svg";